export default {"src":"/_next/static/media/delivery-truck.d54efaec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};